import { Component, Input, OnChanges, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Product, Url } from '@vestiaire/api-sdk-angular';

@Component({
  selector: 'vc-product-categories-suggestions',
  templateUrl: './product-categories-suggestions.component.html',
  styleUrls: ['./product-categories-suggestions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductCategoriesSuggestionsComponent implements OnInit, OnChanges {
  @Input()
  product: Product;
  public bottomLinks: Array<{
    name: string;
    localizedName: string;
    url: Url;
  }> = [];

  constructor() {}

  ngOnInit() {}

  ngOnChanges() {
    if (this.product && this.product.meshLinks) {
      this.bottomLinks = [];
      Object.keys(this.product.meshLinks).forEach(key => {
        this.bottomLinks.push(this.product.meshLinks[key]);
      });
    }
  }
}
